export class MasterData {

  public id: string;
  public countryCode?: string;
  public carrierCode?: any[];
  public assetId?: string;
  public assetType?: string;
  public status?: string;
  public contractStartDate?: string;
  public contractEndDate?: string;
  public distanceTravel?: string;
  public distanceUnit?: string;
  public chargeType?: string;
  public orderType?: string;
  public rentCharges?: string;
  public frequency?: string;
  public labourCharges?: string;
  public extraDistanceCharges?: string;
  public fuelCharges?: string;
  public tollCharges?: string;
  public otherCharges?: string;
  public totalCharges?: string;
  public currency?: string;
  public charges?: DFVariableCharges[];
  public fixedChargeFrequency?: string;
  public error?: string;
  public assetCharges?: DFAssetCharges[];

  static fromDto(r) {
    if (!r) {
      return null;
    }
    const result           = new MasterData();
    result.id = r.id;
    result.countryCode = r.country_code;
    result.carrierCode = r.carrier_code;
    result.assetId = r.asset_id;
    result.assetType = r.asset_type;
    result.status = r.status;
    result.contractStartDate = r.contract_start_date;
    result.contractEndDate = r.contract_end_date;
    result.distanceTravel = r.distance_travel;
    result.distanceUnit = r.distance_unit;
    result.chargeType = r.charge_type;
    result.orderType = r.order_type;
    result.rentCharges = r.rent_charges;
    result.labourCharges = r.labour_charges;
    result.extraDistanceCharges = r.extra_distance_charges;
    result.fuelCharges = r.fuel_charges;
    result.tollCharges = r.toll_charges;
    result.otherCharges = r.other_charges;
    result.totalCharges = r.total_charges;
    result.currency = r.currency;
    result.charges = r.charges;
    result.fixedChargeFrequency = r.fixed_charge_frequency;
    result.error = r.error;
    result.assetCharges = r.assetCharges;
    return result;
  }

  static toDto(r: MasterData): any {
    if (!r) {
      return null;
    }

    return {
    id:  r.id,
    country_code: r.countryCode,
    carrier_code: r.carrierCode,
    asset_id: r.assetId,
    asset_type : r.assetType,
    status : r.status,
    contract_start_date : r.contractStartDate,
    contract_end_date : r.contractEndDate,
    distance_travel : r.distanceTravel,
    distance_unit : r.distanceUnit,
    charge_type : r.chargeType,
    order_type : r.orderType,
    rent_charges : r.rentCharges,
    labour_charges : r.labourCharges,
    extra_distance_charges : r.extraDistanceCharges,
    fuel_charges : r.fuelCharges,
    toll_charges : r.tollCharges,
    other_charges : r.otherCharges,
    total_charges : r.totalCharges,
    currency : r.currency,
    charges: r.charges,
    fixed_charge_frequency: r.fixedChargeFrequency,
    error: r.error,
    assetCharges: r.assetCharges
    };
  }

}

export class DFContract {
   id: string;
   countryCode?: string;
   carrierCode?: number;
   assetId?: string;
   assetType?: string;
   status?: string;
   contractStartDate?: string;
   contractEndDate?: string;
   distanceTravel?: string;
   distanceUnit?: string;
   chargeType?: string;
   orderType?: string;
   rentCharges?: string;
   frequency?: string;
   labourCharges?: string;
   extraDistanceCharges?: string;
   fuelCharges?: string;
   tollCharges?: string;
   otherCharges?: string;
   totalCharges?: string;
   currency?: string;
   charges?: DFVariableCharges[];
   assetCharges?: DFAssetCharges[];
   fixedChargeFrequency?: string;
   error?: string;
}

export class DFAssetCharges {
  assetChargeDto: string;
  id: string;
  country_code: string;
  carrier_code: string;
  asset_id: string;
  asset_type: string;
  status: string;
  contract_start_date: string;
  contract_end_date: string;
  charge_type: string;
  charge_code: string;
  charge_amount: string;
  currency: string;
  asset_charge_id: string;
}

export class DFVariableCharges {
  id: string;
  charge_type: string;
  charge_code: string;
  charge_amount: string;
}

export class DFFieldValidate {
  contractStartDate: boolean;
  contractEndDate: boolean;
  dfDistance: boolean;
  contractedTruckRentCharges: boolean;
  removeBtn: boolean;
  submitBtn: boolean;
}
